<template>
   <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div v-else>
          <!-- Keep-alive should wrap <router-view /> -->
         
    <div class="homepage d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary header_new">
            <div class="d-flex align-items-center">
         
               <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;
                  
                  <span>
                     <h4 class="text-white">{{language?.class}}</h4>
                  </span>
         
            
               <div class="d-flex align-items-center gap-2 ms-auto">
                
                 <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas" data-bs-target="#branch"
                  aria-controls="branch">
                  <b class="bg-dark bg-opacity-75 rounded-circle user-icon">
                  <i class="bi bi-plus  d-flex m-1 h4 text-white"></i>
                  </b>
                  </a>
               </div>
            </div>
            



         </div>
    
         <!-- body -->
         <div class="my-auto overflow-auto vh-100">
           
            <!-- Top Evets -->
            <div class="pt-3 bg_card">
               
               <div class="row">
                  <!-- 1st item -->
                  <div class="">
                        <h4>List</h4>
                     <div class="card  border-1 overflow-hidden " v-for="(item,i) in classlist">
                           
                                <div class="card-body">
                                    <span> {{i+1}}</span> ) 
                                   <strong> {{item.name}}</strong><br>
                                    <span :class="['status-indicator', item.status == 1 ? 'active' : 'inactive']">
                                        {{ item.status == 1 ? 'Active' : 'Inactive' }}
                                      </span>

                               
                                </div> 
                            
                        <div
                           class="card-footer ">
                           <div>
                              <span class="badge bg-success" @click="editBranch(item)"><i class="bi bi-pen"></i> &nbsp;Edit</span> &nbsp; &nbsp; 
                              <span class="badge bg-danger" @click="deleteaddclass(item.id)"><i class="bi bi-trash"></i> &nbsp; Delete</span>
                           </div>
                            
                        </div>

                     </div> 
                  </div> 
                  
               </div> 
            </div>

       


 


  
         </div>
         
         <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="branch" aria-labelledby="branchLabel">
         <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
            <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>
            <h6 class="offcanvas-title text-white m-0" id="branchLabel">{{language?.add_class}}</h6>
         </div>
         <div class="offcanvas-body">

     
           
                
                    <div class="mb-3">
                        <!-- <label for="mobile" class="form-label">{{language?.branch_name}}</label> -->
                         <label for="mobile" class="form-label">Name</label>
                        <input type="text" id="mobile" v-model="addclass.name" class="form-control" required>
                    </div>
                    
                    <div class="mb-3">
                            <label for="status" class="form-label">Status</label>
                            <select id="status" v-model="addclass.status" class="form-control">
                                <option value="1">Active</option>
                                <option value="0">Deactive</option>
                            </select>
                            </div>

                  <div class="d-flex gap-2">
                    <button class="btn btn-primary w-100 " @click="addClass">Save</button>
                    <button class="btn btn-secondary w-50" @click="goprevious">Back</button>
                  </div>
                 
         </div>
      </div>
      </div>
    </div>
</template>

<style scoped>
.header_new {
    border-radius: 0px 0px 20px 20px;
}

.bi {
    height: 35px;
    width: 35px;
    justify-content: center;
    align-items: center;
}
.status-indicator {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.status-indicator.active {
  background: rgba(76, 175, 80, 0.1);
  color: #4caf50;
}

.status-indicator.inactive {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}
</style>
  
<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  components: { 
  },
  mounted() { 
   //  this.fetchWeather();
    this.getBranches(); // Call the method here
    
},
  data() {
    return { 
      loading:false,
      error:null,
      isUserLogged:false,
      user_details:[],
      language: this.getLocalStorageArray('lang'),
      addclass:{
         name:'',
         status:1
      },
      classlist:[], 
      branch_name:'',

    }
  },
  methods:{
    initializeHomeContent(){
    

    },
    goBack() {
          
          this.$router.go(-1);
  },
  goprevious() {
          
          this.$router.go("/branch");
  },

 
  
    async getBranches() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getaddclass").then((response) => {
               self.classlist=response.data.classlist;
               self.language=response.data.language;
               localStorage.setItem('lang',response.data.language);
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 





       addClass() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
           if(self.addclass.name == ''){


             self.$swal.fire("Name is Required!");


           }else{



         
            axios.post("addclass",self.addclass).then((response) => {
              
                        self.classlist=response.data.classlist;
                        self.language=response.data.language;
                     self.$swal.fire(response.data.message);
                     if(response.data.success)
                     {
                        self.branch={ name:'',         address:'',contact:'',};
                     }
                     window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
                      

               
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
           }

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 


      editBranch(editBranch) {
         window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).show();
         this.addclass=editBranch;
      }, 





      deleteaddclass(id = "") {
    this.loading = true;
    this.error = null;

    try {
        var self = this;

        this.$swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post("deleteaddclass", { id: id }).then((response) => {
                     self.classlist=response.data.classlist;
                    self.$swal.fire(response.data.message);
                    
                    if (response.data.success) {
                        window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
                    }
                }).then(() => {
                    self.initializeHomeContent();
                }).catch((err) => {
                    self.$swal.fire("Error!", "Something went wrong.", "error");
                });
            }
        });

    } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
    } finally {
        this.loading = false;
    }
},

        getLocalStorageArray(key) {
                let data = localStorage?.getItem(key);
                try {
                    return data ? JSON.parse(data) : [];
                } catch (e) {
                    console.error("Error parsing localStorage data", e);
                    return [];
                }
            }



















  }
}






</script>
